export default __webpack_public_path__ + "static/DEIPage-pattern-large-indigo-8e4bec97b0a9a433d6f6065bd54ff518.png";